import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { doDeleteBlockingById, openCloseModalDeleteBlocking, deleteBlock } from "./actions";
import BlockingValidation from "./wizard/blockingValidation";
import moment from "moment"

class ModalDeleteBlocking extends React.PureComponent {
  handleClose = () => {
    this.props.dispatch(openCloseModalDeleteBlocking(false, null));
    this.props.stopSignalR()
  }

  handleDelete = () => {
    const _blocking = { ...this.props.dataBlockingToDelete };
    let obj = {};
    obj.Id = _blocking.isNewConfig ? null : _blocking.Id;
    obj.OfficeId = this.props.centerId;
    obj.BlockName = _blocking.NameBlocking;
    obj.BlockAll = _blocking.BlockAll;
    obj.BlockingReasonId = _blocking.BlockingReasonId;
    obj.BlockComment = _blocking.comment;
    obj.CreationDate = moment(new Date()).format();
    obj.BlockUserRut = this.props.userData.RUT;
    obj.BlockDate = _blocking.BlockDate;
    this.props.dispatch(deleteBlock(obj, this.props.connectionHub))  
  }
  renderDeleteMessege = () => (
    <div>
      {this.props.isLoading && <LoadingOverlay />}

      <div className="text-center" style={{ marginTop: 20 }}>
        ¿Quieres eliminar el bloqueo?
      </div>
      <div className="button-row">
        <div>
          <Button
            text="Cancelar"
            onClick={this.handleClose}
          />
        </div>
        <div>
          <Button
            text="Eliminar"
            type="danger"
            onClick={this.handleDelete}
          />
        </div>
      </div>
    </div>
  )


  render() {
    const {
      validationBlocking,
    } = this.props;
    return (
      <Popup
        visible={this.props.isOpenModalDeleteBlocking}
        title="Eliminar bloqueo"
        onHiding={this.handleClose}
        showCloseButton
        dragEnabled={false}
        height={250}
        width={550}
      >
        <div>
          {
            validationBlocking.openValidation === false ? this.renderDeleteMessege() : <BlockingValidation />

          }
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.bloqueosSel.isLoading,
  dataBlockingToDelete: state.bloqueosSel.dataBlockingToDelete,
  isOpenModalDeleteBlocking: state.bloqueosSel.isOpenModalDeleteBlocking,
  validationBlocking: state.bloqueosSel.validationBlocking,
  userData: state.global.userData,
  centerId: state.bloqueosSel.centerId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDeleteBlocking);
